import { render, staticRenderFns } from "./SwappTasksAdmin.vue?vue&type=template&id=62608e14&scoped=true&"
import script from "./SwappTasksAdmin.vue?vue&type=script&lang=js&"
export * from "./SwappTasksAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62608e14",
  null
  
)

export default component.exports